import React from 'react'
import clsx from 'clsx'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import VolumeUpIcon from 'components/material-symbol/icons/VolumeUp'
import {
  CALLOUT_BACKGROUND,
  PROMO_CALLOUT_BACKGROUND,
} from 'lib/form-field-styles'
import { usePromotions } from './promotions-context'

const useStyles = makeStyles(theme => ({
  strip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.25, 1, 0.25, 2),
    backgroundColor: PROMO_CALLOUT_BACKGROUND,
    color: theme.palette.text.primary,
  },
  stripOff: {
    backgroundColor: CALLOUT_BACKGROUND,
    color: theme.palette.text.secondary,
  },
  icon: {
    fontSize: '1.125rem',
    flexShrink: 0,
  },
  text: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  state: {
    fontWeight: 600,
  },
  action: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
}))

const PromotionsStrip = () => {
  const classes = useStyles()
  const promotions = usePromotions()
  if (!promotions) return null

  const { coachName, enabled, saving, openSheet, turnOn } = promotions

  return (
    <div
      className={clsx(classes.strip, !enabled && classes.stripOff)}
      data-testid="promotions-strip"
    >
      <VolumeUpIcon className={classes.icon} aria-hidden />
      <Typography variant="caption" className={classes.text}>
        Promotions from {coachName} are{' '}
        <span className={classes.state}>{enabled ? 'on' : 'off'}</span>
      </Typography>
      <Button
        size="small"
        color="primary"
        disabled={saving}
        className={classes.action}
        onClick={enabled ? openSheet : turnOn}
      >
        {enabled ? 'Manage' : 'Turn on'}
      </Button>
    </div>
  )
}

export default PromotionsStrip
